import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";

export default class WheelStartTransitions extends AbstractSceneTransition {

    public in(): Contract<void> {
        return new Contract((resolve) => {
            const fs = Layers.Custom.get("Transition").getSpine("fs");
            fs.play(0, "fs_wheel_transition", false);
            fs.state.tracks[0].listener = {
                complete: (trackEntry) => {
                    fs.state.tracks[0].listener = null;
                    resolve(null);
                }
            }
        });
    }
}
        